import dayjs from "dayjs";
import dayjsutc from "dayjs/plugin/utc"; // dependent on utc plugin
import dayjstimezone from "dayjs/plugin/timezone";
dayjs.extend(dayjsutc);
dayjs.extend(dayjstimezone);

import React from "react";
import ReactDom from "react-dom";
import * as ReactRedux from "react-redux";
import { store } from "./store";
import { Router } from "./router";
import { getVersions } from "./services/common/common";
import "mapbox-gl/dist/mapbox-gl.css";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { Global, css } from "@emotion/react";
import { theme, colorsCSS } from "./theme"; // mui theme, colors
import "./theme/styles.scss"; // global styles
import "./styles.module.scss";

const init = async () => {
    getVersions();
};

init();

ReactDom.render(
    <ReactRedux.Provider store={store}>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Global styles={css(colorsCSS())} />
            <Router />
        </ThemeProvider>
    </ReactRedux.Provider>,
    document.getElementById("container")
);
